<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from '../../modules/vodafone_lab_mixins_module.js';

export default {
  mixins: [fandomBasicMixin, vodafoneLabBasicMixin],
  props: {
    width: {
      type: Number,
      default: 7
    }
  },
  data: function () {
    return {};
  },
  computed: {
    columnClass() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : this.width;
      return `col-lg-${columnWidth}`;
    },
  },
  methods: {
    expandUrl: Fandom.expandUrl,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTarget: Fandom.getTarget,
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentType"
    class="px-0 inview_animate"
    v-if="isContentVisibleToUser()" 
    list-keyopints-tile-component
    :id="content.name"
  >
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container">
      <div class="row justify-content-center">
        <div :class="columnClass" class="col-12">
          <h3 :style="{'text-align': content.text_align || 'left'}" v-if="content.title">{{content.title}}</h3>
          <div class="row inset py-4 mt-md-5 mx-md-0">
            <div class="col-sm-6 keypoint-col py-4 pt-md-0" v-for="(keypoint, index) in content.keypoints" :key="`keypoints-${index}`">
              <div class="keypoint-image ar-1by1 w-100 bg-cover-center" :style="{ 'background-image': getBackgroundUrl(keypoint.image.url) }"></div>
              <div class="keypoint-text">
                <h3 class="h4 font-weight-bold mt-3 my-2">{{keypoint.title}}</h3>
                <p v-html="keypoint.description"></p>
                <a
                  v-if="keypoint.button"
                  :href="keypoint.button.url"
                  :target="getTarget(keypoint.button)"
                  class="btn"
                  :class="keypoint.button_class || 'btn-primary'"
                >{{keypoint.button.title}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[list-keyopints-tile-component] {

  .text-bold {
    font-family: VodafoneRg;
    font-weight: bold;
  }

  @include media-breakpoint-up(md) {

    .keypoint-col:nth-child(odd) {
      padding-right: 12px;
      padding-left: 0;
    }

    .keypoint-col:nth-child(even) {
      padding-left: 12px;
      padding-right: 0;
    }
  }

}

</style>